import { put } from 'redux-saga/effects'
import importer from 'common/importer'
/* ENDPOINTS */
const { okta } = importer('APIs/auth', null)
const { getSessionUser } = okta
/* ACTIONS */
const UserActions = importer('Stores/Users/Actions')
export default function * main () {
  try {
    yield put(UserActions.getSessionUserLoading())
    const res = yield getSessionUser()
    if (res.status === 200 || res.status === 304) {
      yield put(UserActions.getSessionUserSuccess(res.data))
    } else {
      throw Error(res)
    }
  } catch (error) {
    yield put(UserActions.getSessionUserFailure(error))
  }
}
